// extracted by mini-css-extract-plugin
export default {"account":"MyAccount__account--mi_"};